package com.milta.feature.admin.presentation

import com.milta.core.mvi.MviViewModel
import com.milta.core.network.ApiException
import com.milta.feature.admin.domain.usecase.GetAdminOcrAnalysisUseCase
import kotlinx.coroutines.launch

/** ViewModel for the Admin "Usage IA" screen (2026-10-05) — background OCR analysis pipeline
 * cost-comparison view, read-only, no intent beyond the initial load. */
class AdminOcrAnalysisViewModel(
    private val getAdminOcrAnalysis: GetAdminOcrAnalysisUseCase,
) : MviViewModel<AdminOcrAnalysisState, AdminOcrAnalysisIntent>(AdminOcrAnalysisState()) {

    init {
        onIntent(AdminOcrAnalysisIntent.Load)
    }

    override fun onIntent(intent: AdminOcrAnalysisIntent) {
        when (intent) {
            AdminOcrAnalysisIntent.Load -> load()
        }
    }

    private fun load() {
        scope.launch {
            setState { copy(isLoading = true, error = null) }
            getAdminOcrAnalysis().fold(
                onSuccess = { analysis -> setState { copy(isLoading = false, analysis = analysis) } },
                onFailure = { e ->
                    val errorCode = if (e is ApiException) "server_error" else "offline"
                    setState { copy(isLoading = false, error = errorCode) }
                },
            )
        }
    }
}
